<div class="chat-vform" [class.chat-vform--done]="answered">
  <span class="chat-vform__icon"><chat-icon name="file" [size]="16"></chat-icon></span>
  <div class="chat-vform__body">
    <div class="chat-vform__title">{{ strings.visitFormTitle }}<span *ngIf="when" class="chat-vform__when"> · {{ when }}</span></div>
    <div class="chat-vform__sub">
      {{ answered ? strings.visitFormAnswered : strings.visitFormPending }}
      <span *ngIf="stars.length > 0" class="chat-vform__stars" aria-hidden="true">
        <span *ngFor="let on of stars" class="chat-vform__star" [class.chat-vform__star--on]="on">★</span>
      </span>
    </div>
    <div class="chat-vform__actions">
      <a *ngIf="params.url" class="chat-vform__btn chat-vform__btn--primary" [href]="params.url" target="_blank" rel="noopener">{{ strings.visitFormOpen }}</a>
      <button *ngIf="canManage && params.url" type="button" class="chat-vform__btn" (click)="copy.emit()">{{ strings.visitFormCopyLink }}</button>
    </div>
  </div>
</div>
